export const ON_CART_GO_TO_BASKET_WARN =
  'ProductInfoContainer: GA middleware in the basket modal did not fire in time.';
